export type SizeLike =
  | string
  | {
      value?: string | null;
      label?: string | null;
    };

const normalizeToken = (value: string) => value.replace(/"/g, '').trim();
const numericSizePattern = /^\d+(?:\.5)?$/;

export const getSizeValues = (sizes?: SizeLike[] | null) => {
  const values = (sizes || []).flatMap((size) => {
    const rawValue = typeof size === 'string'
      ? size
      : size.value || size.label || '';

    return rawValue
      .split(',')
      .map(normalizeToken)
      .filter(Boolean);
  });

  return Array.from(new Set(values));
};

export const getSizesForMaterial = <
  T extends {
    materialName?: string | null;
    sizes?: SizeLike[] | null;
  }
>(
  materials: T[] | undefined,
  selectedMaterial?: string | null
) =>
  getSizeValues(
    materials?.find((material) => material.materialName === selectedMaterial)?.sizes
  );

export const getProductSizeValues = <
  T extends {
    materialName?: string | null;
    sizes?: SizeLike[] | null;
  }
>(
  productSizes?: SizeLike[] | null,
  materials?: T[],
  selectedMaterial?: string | null
) => {
  const materialSizes = getSizesForMaterial(materials, selectedMaterial);

  return materialSizes.length ? materialSizes : getSizeValues(productSizes);
};

export const formatSizeLabel = (size?: string | null) => {
  const value = normalizeToken(String(size || ''));

  if (!value) {
    return '';
  }

  return numericSizePattern.test(value) ? `${value} US` : value;
};
